export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-cinema-bg">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20interior%20with%20warm%20golden%20spotlight%20beams%2C%20empty%20red%20velvet%20seats%2C%20dramatic%20lighting%2C%20luxury%20cinema%20atmosphere%2C%20wide%20angle%20shot%2C%20rich%20contrast%20between%20light%20and%20shadow&width=1800&height=900&seq=hero-bg-cinema-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-cinema-bg/70 via-cinema-bg/50 to-cinema-bg"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-cinema-gold/15 border border-cinema-gold/30 mb-6">
              <div className="w-2 h-2 rounded-full bg-cinema-gold animate-pulse"></div>
              <span className="text-xs text-cinema-gold-light font-medium whitespace-nowrap">实时更新 · 每日上新</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-4">
              黄瓜影院
              <span className="block text-cinema-gold mt-1">影视搜索快速找片 · 高清在线流畅播放</span>
            </h1>

            <p className="text-cinema-text-dim text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              黄瓜影院为您提供一站式的影视搜索与在线观看体验。智能推荐算法精准匹配您的观影口味，
              海量片库涵盖电影、电视剧、动漫、综艺全品类，高清画质流畅不缓冲。
              无论是最新热播剧集还是经典高分电影，即点即播，随时随地畅享极致观影。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-cinema-gold">10万+</div>
                <div className="text-xs text-cinema-muted mt-1">收录资源</div>
              </div>
              <div className="w-px h-10 bg-cinema-border hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-cinema-gold">3000万+</div>
                <div className="text-xs text-cinema-muted mt-1">月活用户</div>
              </div>
              <div className="w-px h-10 bg-cinema-border hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-cinema-gold">每日更新</div>
                <div className="text-xs text-cinema-muted mt-1">新片速递</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 bg-cinema-gold hover:bg-cinema-gold-dark text-cinema-bg font-semibold rounded-md transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line mr-2"></i>查看热度榜单
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 border border-cinema-border hover:border-cinema-gold/50 text-cinema-text hover:text-cinema-gold rounded-md transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line mr-2"></i>探索专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-1 bg-gradient-to-r from-cinema-gold/20 via-cinema-accent/20 to-cinema-gold/20 rounded-xl blur-xl"></div>
              <div className="relative bg-cinema-card rounded-xl overflow-hidden border border-cinema-border">
                <img
                  src="https://readdy.ai/api/search-image?query=Movie%20poster%20collage%20with%20dramatic%20Chinese%20film%20scenes%2C%20warm%20amber%20and%20gold%20color%20palette%2C%20cinematic%20composition%2C%20suspense%20detective%20and%20sci-fi%20themes%2C%20modern%20film%20poster%20design%2C%20dark%20background%20with%20vibrant%20accents&width=800&height=1000&seq=hero-poster-01&orientation=portrait"
                  alt="黄瓜影院热门影片合集"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-cinema-bg via-cinema-bg/60 to-transparent p-5">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-cinema-accent animate-pulse"></div>
                    <span className="text-xs text-cinema-text-dim">热门影片实时更新中</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}